var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.orderId)?_c('div',[(_vm.orderRoute)?_c('router-link',{attrs:{"to":_vm.orderRoute,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(_vm.orderId))])]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }